import {
  put, call, select, delay,
} from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import {
  groupDeleteFileFailed,
  groupDeleteFileSuccessful,
} from '../actions';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';
import {
  addProgressLog, setProgressList, showProgressBar, signDocument,
} from '../../System/actions';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import processError from '../../../utils/processError';

const getStop = state => {
  const {
    [SYSTEM_MODULE]: {
      stopProgressBar = false,
    },
  } = state;
  return stopProgressBar;
};

export default function* groupDeleteFile(action) {
  try {
    const {
      payload: {
        filter,
      } = {},
    } = action;
    const url = `${BACKEND_URL}/resolutions/get-for-sign-list`;
    let pool = { limit: 0, offset: 0 };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = addFilterQueryWithCondition(filter, pool);
    }

    yield put(showProgressBar({
      title: 'Пакетное удаление файлов',
      text: 'group.delete.file',
    }));
    yield put(addProgressLog({ log: 'Загрузка списка файлов.' }));
    yield put(addProgressLog({ log: 'Список документов загружен.' }));
    yield put(setProgressList({ progressCount: 50 }));
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    if (dataResponse.status === OK) {
      const responseJson = yield dataResponse.json();
      if (!responseJson || !responseJson.data || !responseJson.data.list || !responseJson.data.list.length) {
        yield put(addProgressLog({ log: 'Не найдены файлы для подписания.' }));
        throw new Error('Не найдены файлы для подписания.');
      }
      const { list } = responseJson.data;
      yield put(addProgressLog({ log: 'Список документов загружен.' }));
      yield put(setProgressList({ progressCount: responseJson.data.total }));
      let stopSigned = false;
      for (let i = 0, len = list.length; i < len; i++) {
        stopSigned = yield select(getStop);
        if (stopSigned) {
          break;
        }
        try {
          yield put(addProgressLog({ log: 'Файл удален.', incSuccess: true }));
        } catch (e) {
          yield put(addProgressLog({ log: `<span class='red-text'>Документ «${document.name}» не подписан.</span>`, incError: true }));
        }
      }
      yield put(addProgressLog({ log: 'Подписание окончено.' }));
      if (!stopSigned) {
        yield put(groupDeleteFileSuccessful());
        yield call(resolveActionPromise(action, {}));
      }
    } else {
      yield put(groupDeleteFileFailed([]));
      yield call(rejectActionPromise(action));
      yield put(addProgressLog({ log: '<span class=\'red-text\'>Список файлов не загружен.</span>', incError: true }));
    }
  } catch (e) {
    yield put(groupDeleteFileFailed([]));
    yield call(rejectActionPromise(action, {}));
    yield processError(e);
  }
}
